var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14.01c0-.41.205-.615.665-.615 4.337.045 9.728-3.737 14.4-7.015.677-.475 1.34-.94 1.98-1.38v5.27c3.497-2.175 7.093-3.92 10.29-3.888.46 0 .665.154.665.614v10.545c0 .41-.205.615-.666.615-4.343-.09-9.743 3.699-14.42 6.98-.67.469-1.325.928-1.96 1.364v-5.228c-3.51 2.18-7.12 3.928-10.289 3.896-.46 0-.665-.153-.665-.614V14.009z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoti);
export default __webpack_public_path__ + "static/media/COTI.01b4c1683280ca7aa2a54e6485a07f2f.svg";
export { ForwardRef as ReactComponent };